import { useTamdaMediaSettingsStore } from "@/stores/use-tamda-media-settings-store"
import { useEffect } from "react"

export const useTamdaMediaSettings = () => {
  const settings = useTamdaMediaSettingsStore(state => state.settings)
  const loading = useTamdaMediaSettingsStore(state => state.loading)

  useEffect(() => {
    const currentSettings = useTamdaMediaSettingsStore.getState().settings
    if (!currentSettings) {
      useTamdaMediaSettingsStore.getState().fetchSettings()
    }
  }, [])

  return { settings, loading }
}

